import {Status} from './status/status'
import {StatusSvc} from './status/status.svc'
export {Status} from './status/status'
export {StatusSvc} from './status/status.svc'
export const STATUS_PROVIDERS:Array<any> = [StatusSvc]


/** WEBPACK FOOTER **
 ** ./src/app/service/status.ts
 **/